/**
 * @generated SignedSource<<f00113321550d2c9ac047b155f85c6cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type similarAuctionTracking_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly categoryPath: string | null;
  readonly contemporaryTrackingString: string;
  readonly ecommerceTrackingParams: any | null;
  readonly relevantAuctionLot: {
    readonly buyItNowPrice: {
      readonly amount: number | null;
    } | null;
  } | null;
  readonly relevantAuctionSolution: {
    readonly bids: {
      readonly totalResults: number | null;
    } | null;
    readonly highestBidAmount: {
      readonly amount: number | null;
    } | null;
  } | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "similarAuctionTracking_item";
};
export type similarAuctionTracking_item$key = {
  readonly " $data"?: similarAuctionTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"similarAuctionTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "similarAuctionTracking_item"
};

(node as any).hash = "3e07ee6341c3bc5aa867aa65667ea851";

export default node;
